export enum TaskPriority {
    Low = 0,
    Medium = 1,
    High = 2,
}

export const TaskPriorityLabels: Record<TaskPriority, string> = {
    [TaskPriority.Low]: 'Low',
    [TaskPriority.Medium]: 'Medium',
    [TaskPriority.High]: 'High',
};

export interface TaskItem {
    id: string;
    title: string;
    description: string;
    dueDate: string | null;
    isCompleted: boolean;
    priority: TaskPriority;
    assignedToUserId: string | null;
    createdAt: string;
    completedAt: string | null;
}

